/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { areaOfStudySchema } from '@axiom/domain';
import { AreaOfStudyCategory } from '../../../enums/generated/area-of-study-category';

/** CreateAreasOfStudyRequest — dark-roast DTO: AreaOfStudyDTO */
export const createAreasOfStudyRequestSchema = areaOfStudySchema.pick({ "id": true, "name": true }).extend({ "id": areaOfStudySchema.shape.id.nullish(), "name": areaOfStudySchema.shape.name.nullish(), "category": z.nativeEnum(AreaOfStudyCategory).nullish(), "isStem": z.boolean() });
export type CreateAreasOfStudyRequest = z.infer<typeof createAreasOfStudyRequestSchema>;
